import { Component, Inject, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import ResetPasswordView from './auth-reset-password.component.html';

@Component({
    selector: 'auth-reset-password',
    template: ResetPasswordView
})
export class AuthResetPasswordComponent implements OnInit {

    token: string = '';
    newPassword: string = '';
    confirmPassword: string = '';
    loading: boolean = false;
    validatingToken: boolean = true;
    success: boolean = false;
    errorMessage: string = '';
    tokenInvalid: boolean = false;
    newPasswordVisible: boolean = false;
    confirmPasswordVisible: boolean = false;

    readonly strengthBars = [1, 2, 3, 4];

    // Regex igual al backend: 8+ chars, mayúscula, minúscula, número, especial
    readonly strongRegex = '^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[^a-zA-Z0-9]).{8,}$';

    constructor(
        @Inject('$stateParams') private $stateParams: any,
        @Inject('$state') private $state: any,
        @Inject(HttpClient) private http: HttpClient
    ) {}

    ngOnInit(): void {
        this.token = this.$stateParams.token || '';
        if (!this.token) {
            this.tokenInvalid = true;
            this.validatingToken = false;
            return;
        }
        this.http.get(`/api/Auth/ValidateResetToken?token=${encodeURIComponent(this.token)}`).subscribe({
            next: () => { this.validatingToken = false; },
            error: () => { this.tokenInvalid = true; this.validatingToken = false; }
        });
    }

    get passwordsMatch(): boolean {
        return this.newPassword === this.confirmPassword;
    }

    get passwordIsStrong(): boolean {
        return new RegExp(this.strongRegex).test(this.newPassword);
    }

    get canSubmit(): boolean {
        return !!this.token && this.passwordIsStrong && this.passwordsMatch && !this.loading;
    }

    get passwordStrength(): number {
        const p = this.newPassword;
        if (!p) return 0;
        let score = 0;
        if (/[a-z]/.test(p)) score++;
        if (/[A-Z]/.test(p)) score++;
        if (/[0-9]/.test(p)) score++;
        if (/[^a-zA-Z0-9]/.test(p)) score++;
        return score;
    }

    get passwordStrengthLabel(): string {
        const s = this.passwordStrength;
        if (s <= 1) return 'Débil';
        if (s <= 3) return 'Media';
        return 'Fuerte';
    }

    get passwordStrengthColor(): string {
        const s = this.passwordStrength;
        if (s <= 1) return '#ef4444';
        if (s <= 3) return '#f59e0b';
        return '#22c55e';
    }

    submit(): void {
        if (!this.canSubmit) return;
        this.loading = true;
        this.errorMessage = '';

        this.http.post('/api/Auth/ResetPassword', {
            token: this.token,
            newPassword: this.newPassword
        }).subscribe({
            next: () => {
                this.loading = false;
                this.success = true;
                setTimeout(() => this.$state.go('login'), 3000);
            },
            error: (err) => {
                this.loading = false;
                this.errorMessage = err?.error?.Message || err?.error || 'Ha ocurrido un error. Inténtalo de nuevo.';
            }
        });
    }

    goToLogin(): void {
        this.$state.go('login');
    }
}
